
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import WelcomeHeader from './components/WelcomeHeader';
import QuickActions from './components/QuickActions';
import MedicalServices from './components/MedicalServices';
import RecentBookings from './components/RecentBookings';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        rightAction={
          <div className="flex items-center gap-3">
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors">
              <i className="ri-search-line text-lg text-[#333333]"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors relative">
              <i className="ri-notification-3-line text-lg text-[#333333]"></i>
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-[#FF3B30] rounded-full"></div>
            </button>
          </div>
        }
      />
      
      <div className="pt-20 pb-24 px-4 space-y-6">
        <WelcomeHeader />
        <QuickActions />
        <MedicalServices />
        <RecentBookings />
      </div>
      
      <BottomNavigation />
    </div>
  );
}
